import types from '../types';

export const initialState = 0;

export default function vendorIdReducer(state = initialState, action) {
  switch (action.type) {
    case types.SET_VENDOR_ID:
      const vendorId = action.payload;
      if(action.payload !== null) {
        return vendorId;
      } else return state;
    default:
      return state;
  }
};
